import { Component } from "@angular/core";

@Component({
  selector: "adaa-ntkpi-card-screen",
  imports: [],
  templateUrl: "./ntkpi-card-screen.html",
  styleUrl: "./ntkpi-card-screen.scss",
})
export class NtkpiCardScreenComponent {}
